export const CACHE_TIMES = {
  // Para: Plan, PlanCategory, PaymentMethod, ExpenseTemplate, FoodItem, MerchandiseItem
  // Estos datos definen la "estructura" del negocio. Rara vez cambian.
  STATIC_DATA: {
    staleTime: 1000 * 60 * 60 * 24, // 24 Horas
    gcTime: 1000 * 60 * 60 * 25, // Mantener en memoria un poco más que el staleTime
    refetchOnMount: false,
  },

  // Para: Client, Machinery
  // Cambian ocasionalmente pero es bueno ver si hay ediciones recientes al entrar.
  MASTER_DATA: {
    staleTime: 1000 * 60 * 30, // 30 Minutos
    refetchOnMount: true, // Al entrar a un detalle de cliente, mejor validar
  },

  // Para: PlanPayment, FoodPayment, MerchandisePayment, Inventory, OtherIncome, Subscription
  // Esto es el "corazón" de la operación. Debe estar actualizado.
  TRANSACTIONAL_DATA: {
    staleTime: 1000 * 60 * 1, // 1 Minuto (frescura corta)
    refetchOnMount: true,
  },
};
